//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'goods-card',
  props: {
    obj: Object
  },
  data() {
    return {
      webServer: this.$config.baseUrl
    }
  }
}
